import React, { useState,useCallback } from "react";
  import {Route, Routes,useNavigate} from 'react-router-dom'
  import CompatiblePage from "../generatedTablePage/CompatiblePage";
import ModalComponent from "../components/Modal";
  import { Outlet } from "react-router-dom";
 


const CompatibleRoutes = () => {
    
    
    return (
        <Routes> 
        
    <Route
    path="/"
    element={<CompatiblePage/>

    }
    />
    

</Routes>
    
        );
    
}
export default CompatibleRoutes










  